// import Footer from "components/footer";
import Header from "components/header";
import DesktopSidebar from "components/sidebar/desktop";
import React from "react";
import { Outlet } from "react-router-dom";

export default function DesktopLayout() {
  return (
    <div className="h-full w-full flex">
      <DesktopSidebar />
      <div className={`w-full flex flex-col gap-2 h-full`}>
        <Header />
        <div className="h-[calc(100%-64px)] px-9 py-4 relative">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
